module.exports = __webpack_public_path__ + "media/ets/itmanagement_banner_df-9c096a9f.png";